// Dynamic Quote Request Form Fields Configuration
// This configuration defines destination-specific fields for the quote request modal

export const QUOTE_REQUEST_FIELDS = {
  // Theme Parks Category (ID: 1)
  1: {
    // Disneyland Resort (ID: 1)
    1: {
      name: 'Disneyland Resort',
      fields: {
        hotelChoice: {
          type: 'select',
          label: 'Hotel Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            // Disney Hotels
            { value: 'grand_californian', label: 'Disney\'s Grand Californian Hotel & Spa' },
            { value: 'paradise_pier', label: 'Disney\'s Pixar Place Hotel' },
            { value: 'disneyland_hotel', label: 'Disneyland Hotel' },
            // Good Neighbor Hotels
            { value: 'anaheim_majestic', label: 'Anaheim Majestic Garden Hotel' },
            { value: 'best_western_plus', label: 'Best Western Plus Pavilions' },
            { value: 'camelot_inn', label: 'Camelot Inn & Suites' },
            { value: 'candy_cane_inn', label: 'Candy Cane Inn' },
            { value: 'castle_inn', label: 'Castle Inn and Suites' },
            { value: 'desert_palms', label: 'Desert Palms Hotel & Suites' },
            { value: 'hotel_menage', label: 'Hotel Menage' },
            { value: 'peacock_suites', label: 'Peacock Suites' },
            { value: 'tropicana_inn', label: 'Tropicana Inn & Suites' }
          ]
        },
        ticketOptions: {
          type: 'select',
          label: 'Ticket Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: '1_day_1_park', label: '1-Day, 1-Park Ticket' },
            { value: '1_day_park_hopper', label: '1-Day Park Hopper Ticket' },
            { value: '2_day_1_park', label: '2-Day, 1-Park per Day Ticket' },
            { value: '2_day_park_hopper', label: '2-Day Park Hopper Ticket' },
            { value: '3_day_1_park', label: '3-Day, 1-Park per Day Ticket' },
            { value: '3_day_park_hopper', label: '3-Day Park Hopper Ticket' },
            { value: '4_day_1_park', label: '4-Day, 1-Park per Day Ticket' },
            { value: '4_day_park_hopper', label: '4-Day Park Hopper Ticket' },
            { value: '5_day_1_park', label: '5-Day, 1-Park per Day Ticket' },
            { value: '5_day_park_hopper', label: '5-Day Park Hopper Ticket' }
          ]
        },
        roomType: {
          type: 'select',
          label: 'Room Type Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'standard', label: 'Standard Room' },
            { value: 'deluxe', label: 'Deluxe Room' },
            { value: 'suite', label: 'Suite' },
            { value: 'family_suite', label: 'Family Suite' },
            { value: 'concierge', label: 'Concierge Level' }
          ]
        },
        viewPreference: {
          type: 'select',
          label: 'View Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'standard', label: 'Standard View' },
            { value: 'park_view', label: 'Park View' },
            { value: 'premium', label: 'Premium View' },
            { value: 'theme_park_view', label: 'Theme Park View' }
          ]
        },
        addOns: {
          type: 'multiselect',
          label: 'Additional Services',
          required: false,
          options: [
            { value: 'lightning_lane_multipass', label: 'Lightning Lane Multipass' },
            { value: 'individual_lightning_lane', label: 'Individual Lightning Lane' },
            { value: 'photopass', label: 'Disney PhotoPass' },
            { value: 'early_entry', label: 'Early Theme Park Entry' },
            { value: 'character_dining', label: 'Character Dining Reservations' },
            { value: 'spa_services', label: 'Spa Services' },
            { value: 'transportation', label: 'Airport Transportation' }
          ]
        }
      }
    },
    
    // Walt Disney World Resort (ID: 2)
    2: {
      name: 'Walt Disney World Resort',
      fields: {
        hotelChoice: {
          type: 'select',
          label: 'Hotel Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            // Deluxe Resorts
            { value: 'grand_floridian', label: 'Disney\'s Grand Floridian Resort & Spa' },
            { value: 'polynesian', label: 'Disney\'s Polynesian Village Resort' },
            { value: 'contemporary', label: 'Disney\'s Contemporary Resort' },
            { value: 'wilderness_lodge', label: 'Disney\'s Wilderness Lodge' },
            { value: 'animal_kingdom_lodge', label: 'Disney\'s Animal Kingdom Lodge' },
            { value: 'beach_club', label: 'Disney\'s Beach Club Resort' },
            { value: 'yacht_club', label: 'Disney\'s Yacht Club Resort' },
            { value: 'boardwalk', label: 'Disney\'s BoardWalk Inn' },
            { value: 'lakeshore_lodge', label: 'Disney\'s Lakeshore Lodge' },
            { value: 'riviera', label: 'Disney\'s Riviera Resort' },
            // Deluxe Villa Resorts
            { value: 'gf_villas', label: 'The Villas at Disney\'s Grand Floridian Resort' },
            { value: 'bay_lake_tower', label: 'Bay Lake Tower at Disney\'s Contemporary Resort' },
            { value: 'polynesian_villas', label: 'Disney\'s Polynesian Villas & Bungalows' },
            { value: 'boulder_ridge', label: 'Boulder Ridge Villas at Disney\'s Wilderness Lodge' },
            { value: 'copper_creek', label: 'Copper Creek Villas & Cabins at Disney\'s Wilderness Lodge' },
            { value: 'jambo_house', label: 'Disney\'s Animal Kingdom Lodge – Jambo House' },
            { value: 'kidani_village', label: 'Disney\'s Animal Kingdom Lodge – Kidani Village' },
            { value: 'beach_club_villas', label: 'Disney\'s Beach Club Villas' },
            { value: 'boardwalk_villas', label: 'Disney\'s BoardWalk Villas' },
            { value: 'old_key_west', label: 'Disney\'s Old Key West Villas' },
            { value: 'saratoga_springs', label: 'Disney\'s Saratoga Springs Villas' },
            // Moderate Resorts
            { value: 'port_orleans_french', label: 'Disney\'s Port Orleans Resort - French Quarter' },
            { value: 'port_orleans_riverside', label: 'Disney\'s Port Orleans Resort - Riverside' },
            { value: 'coronado_springs', label: 'Disney\'s Coronado Springs Resort' },
            { value: 'caribbean_beach', label: 'Disney\'s Caribbean Beach Resort' },
            { value: 'fort_wilderness_cabins', label: 'The Cabins at Disney\'s Fort Wilderness Resort' },
            // Value Resorts
            { value: 'art_of_animation', label: 'Disney\'s Art of Animation Resort' },
            { value: 'pop_century', label: 'Disney\'s Pop Century Resort' },
            { value: 'all_star_movies', label: 'Disney\'s All-Star Movies Resort' },
            { value: 'all_star_music', label: 'Disney\'s All-Star Music Resort' },
            { value: 'all_star_sports', label: 'Disney\'s All-Star Sports Resort' },
            { value: 'fort_wilderness_campsites', label: 'The Campsites at Disney\'s Fort Wilderness Resort' }
          ]
        },
        ticketOptions: {
          type: 'select',
          label: 'Ticket Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: '1_day_1_park', label: '1-Day Magic Kingdom Ticket' },
            { value: '1_day_epcot', label: '1-Day EPCOT Ticket' },
            { value: '1_day_hollywood', label: '1-Day Hollywood Studios Ticket' },
            { value: '1_day_animal', label: '1-Day Animal Kingdom Ticket' },
            { value: '2_day_1_park', label: '2-Day, 1-Park per Day Ticket' },
            { value: '2_day_park_hopper', label: '2-Day Park Hopper Ticket' },
            { value: '3_day_1_park', label: '3-Day, 1-Park per Day Ticket' },
            { value: '3_day_park_hopper', label: '3-Day Park Hopper Ticket' },
            { value: '4_day_1_park', label: '4-Day, 1-Park per Day Ticket' },
            { value: '4_day_park_hopper', label: '4-Day Park Hopper Ticket' },
            { value: '5_day_1_park', label: '5-Day, 1-Park per Day Ticket' },
            { value: '5_day_park_hopper', label: '5-Day Park Hopper Ticket' },
            { value: '7_day_park_hopper', label: '7-Day Park Hopper Ticket' },
            { value: '10_day_park_hopper', label: '10-Day Park Hopper Ticket' }
          ]
        },
        diningPlan: {
          type: 'select',
          label: 'Disney Dining Plan',
          required: false,
          options: [
            { value: '', label: 'No dining plan' },
            { value: 'quick_service', label: 'Disney Quick-Service Dining Plan' },
            { value: 'dining_plan', label: 'Disney Dining Plan' },
            { value: 'deluxe_dining', label: 'Disney Deluxe Dining Plan' }
          ]
        },
        roomType: {
          type: 'select',
          label: 'Room Type Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'standard', label: 'Standard Room' },
            { value: 'preferred', label: 'Preferred Room' },
            { value: 'deluxe', label: 'Deluxe Room' },
            { value: 'suite', label: 'Suite' },
            { value: 'family_suite', label: 'Family Suite' },
            { value: 'concierge', label: 'Concierge Level' },
            { value: 'club_level', label: 'Club Level' }
          ]
        },
        viewPreference: {
          type: 'select',
          label: 'View Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'standard', label: 'Standard View' },
            { value: 'water_view', label: 'Water View' },
            { value: 'lagoon_view', label: 'Lagoon View' },
            { value: 'savanna_view', label: 'Savanna View' },
            { value: 'theme_park_view', label: 'Theme Park View' },
            { value: 'fireworks_view', label: 'Fireworks View' }
          ]
        },
        addOns: {
          type: 'multiselect',
          label: 'Additional Services',
          required: false,
          options: [
            { value: 'lightning_lane_multipass', label: 'Lightning Lane Multipass' },
            { value: 'individual_lightning_lane', label: 'Individual Lightning Lane' },
            { value: 'lightning_lane_premier', label: 'Lightning Lane Premier Pass' },
            { value: 'photopass', label: 'Disney PhotoPass+' },
            { value: 'memory_maker', label: 'Disney Memory Maker' },
            { value: 'early_entry', label: 'Early Theme Park Entry' },
            { value: 'extended_hours', label: 'Extended Evening Hours' },
            { value: 'character_dining', label: 'Character Dining Reservations' },
            { value: 'spa_services', label: 'Spa Services' },
            { value: 'golf', label: 'Golf Reservations' },
            { value: 'transportation', label: 'Airport Transportation' },
            { value: 'magical_express', label: 'Resort Transportation' }
          ]
        }
      }
    },

    // Universal Orlando Resort (ID: 3)
    3: {
      name: 'Universal Orlando Resort',
      fields: {
        hotelChoice: {
          type: 'select',
          label: 'Hotel Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            // Prime Value
            { value: 'endless_summer_surfside', label: 'Universal\'s Endless Summer Resort - Surfside Inn' },
            { value: 'endless_summer_dockside', label: 'Universal\'s Endless Summer Resort - Dockside Inn' },
            // Preferred
            { value: 'cabana_bay', label: 'Universal\'s Cabana Bay Beach Resort' },
            { value: 'sapphire_falls', label: 'Universal\'s Sapphire Falls Resort' },
            // Prime
            { value: 'royal_pacific', label: 'Universal\'s Royal Pacific Resort' },
            { value: 'hard_rock', label: 'Universal\'s Hard Rock Hotel' },
            { value: 'portofino_bay', label: 'Universal\'s Portofino Bay Hotel' }
          ]
        },
        ticketOptions: {
          type: 'select',
          label: 'Ticket Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: '1_day_1_park', label: '1-Day, 1-Park Ticket' },
            { value: '1_day_2_park', label: '1-Day Park-to-Park Ticket' },
            { value: '2_day_1_park', label: '2-Day, 1-Park per Day Ticket' },
            { value: '2_day_2_park', label: '2-Day Park-to-Park Ticket' },
            { value: '3_day_2_park', label: '3-Day Park-to-Park Ticket' },
            { value: '4_day_2_park', label: '4-Day Park-to-Park Ticket' },
            { value: '5_day_2_park', label: '5-Day Park-to-Park Ticket' }
          ]
        },
        roomType: {
          type: 'select',
          label: 'Room Type Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'standard', label: 'Standard Room' },
            { value: 'preferred', label: 'Preferred Room' },
            { value: 'deluxe', label: 'Deluxe Room' },
            { value: 'suite', label: 'Suite' },
            { value: 'family_suite', label: 'Family Suite' },
            { value: 'club_level', label: 'Club Level' }
          ]
        },
        addOns: {
          type: 'multiselect',
          label: 'Additional Services',
          required: false,
          options: [
            { value: 'express_pass', label: 'Universal Express Pass' },
            { value: 'express_unlimited', label: 'Universal Express Unlimited Pass' },
            { value: 'early_admission', label: 'Early Park Admission' },
            { value: 'dining_plan', label: 'Universal Dining Plan' },
            { value: 'photo_package', label: 'Photo Package' },
            { value: 'transportation', label: 'Airport Transportation' }
          ]
        }
      }
    },

    // Universal Studios Hollywood (ID: 4)
    4: {
      name: 'Universal Studios Hollywood',
      fields: {
        hotelChoice: {
          type: 'select',
          label: 'Hotel Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'hilton_universal', label: 'Hilton Los Angeles/Universal City' },
            { value: 'sheraton_universal', label: 'Sheraton Universal Hotel' },
            { value: 'garland', label: 'The Garland' },
            { value: 'chamberlain', label: 'Chamberlain West Hollywood' },
            { value: 'hollywood_roosevelt', label: 'The Hollywood Roosevelt' }
          ]
        },
        ticketOptions: {
          type: 'select',
          label: 'Ticket Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: '1_day_general', label: '1-Day General Admission' },
            { value: '1_day_front_of_line', label: '1-Day Front of Line Pass' },
            { value: '2_day_general', label: '2-Day General Admission' },
            { value: 'annual_pass', label: 'Annual Pass' },
            { value: 'vip_experience', label: 'VIP Experience' }
          ]
        },
        addOns: {
          type: 'multiselect',
          label: 'Additional Services',
          required: false,
          options: [
            { value: 'front_of_line', label: 'Front of Line Pass' },
            { value: 'vip_experience', label: 'VIP Experience' },
            { value: 'behind_scenes', label: 'Behind-the-Scenes Tour' },
            { value: 'photo_package', label: 'Photo Package' },
            { value: 'transportation', label: 'Airport Transportation' }
          ]
        }
      }
    },

    // Other Theme Parks (ID: 5)
    5: {
      name: 'Other Theme Parks',
      fields: {
        parkChoice: {
          type: 'select',
          label: 'Theme Park',
          required: true,
          options: [
            { value: 'six_flags_magic_mountain', label: 'Six Flags Magic Mountain' },
            { value: 'cedar_point', label: 'Cedar Point' },
            { value: 'busch_gardens_tampa', label: 'Busch Gardens Tampa' },
            { value: 'busch_gardens_williamsburg', label: 'Busch Gardens Williamsburg' },
            { value: 'seaworld_orlando', label: 'SeaWorld Orlando' },
            { value: 'seaworld_san_diego', label: 'SeaWorld San Diego' },
            { value: 'knott_berry_farm', label: 'Knott\'s Berry Farm' },
            { value: 'dollywood', label: 'Dollywood' },
            { value: 'silver_dollar_city', label: 'Silver Dollar City' },
            { value: 'hersheypark', label: 'Hersheypark' }
          ]
        },
        hotelChoice: {
          type: 'text',
          label: 'Hotel Preference (Optional)',
          required: false,
          placeholder: 'Enter preferred hotel or area'
        },
        ticketOptions: {
          type: 'select',
          label: 'Ticket Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: '1_day', label: '1-Day Admission' },
            { value: '2_day', label: '2-Day Admission' },
            { value: 'season_pass', label: 'Season Pass' },
            { value: 'fast_pass', label: 'Fast Pass/Skip the Line' }
          ]
        }
      }
    }
  },

  // Cruises Category (ID: 2)
  2: {
    // Caribbean Cruises (ID: 6)
    6: {
      name: 'Caribbean Cruises',
      fields: {
        cruiseLine: {
          type: 'select',
          label: 'Cruise Line Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'royal_caribbean', label: 'Royal Caribbean' },
            { value: 'carnival', label: 'Carnival Cruise Line' },
            { value: 'norwegian', label: 'Norwegian Cruise Line' },
            { value: 'disney', label: 'Disney Cruise Line' },
            { value: 'celebrity', label: 'Celebrity Cruises' },
            { value: 'princess', label: 'Princess Cruises' },
            { value: 'msc', label: 'MSC Cruises' },
            { value: 'virgin', label: 'Virgin Voyages' }
          ]
        },
        cruiseDuration: {
          type: 'select',
          label: 'Cruise Length',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: '3_4_nights', label: '3-4 Nights' },
            { value: '5_6_nights', label: '5-6 Nights' },
            { value: '7_nights', label: '7 Nights' },
            { value: '8_10_nights', label: '8-10 Nights' },
            { value: '11_plus_nights', label: '11+ Nights' }
          ]
        },
        departurePort: {
          type: 'select',
          label: 'Departure Port Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'miami', label: 'Miami, FL' },
            { value: 'fort_lauderdale', label: 'Fort Lauderdale, FL' },
            { value: 'port_canaveral', label: 'Port Canaveral, FL' },
            { value: 'tampa', label: 'Tampa, FL' },
            { value: 'new_orleans', label: 'New Orleans, LA' },
            { value: 'galveston', label: 'Galveston, TX' },
            { value: 'charleston', label: 'Charleston, SC' },
            { value: 'baltimore', label: 'Baltimore, MD' },
            { value: 'new_york', label: 'New York, NY' }
          ]
        },
        cabinType: {
          type: 'select',
          label: 'Cabin Type Preference',
          required: false,
          options: [
            { value: '', label: 'No preference' },
            { value: 'interior', label: 'Interior Cabin' },
            { value: 'oceanview', label: 'Oceanview Cabin' },
            { value: 'balcony', label: 'Balcony Cabin' },
            { value: 'suite', label: 'Suite' },
            { value: 'family_cabin', label: 'Family Cabin' }
          ]
        },
        diningPackage: {
          type: 'select',
          label: 'Dining Package',
          required: false,
          options: [
            { value: '', label: 'No dining package' },
            { value: 'specialty_dining', label: 'Specialty Dining Package' },
            { value: 'beverage_package', label: 'Beverage Package' },
            { value: 'ultimate_dining', label: 'Ultimate Dining Package' }
          ]
        },
        addOns: {
          type: 'multiselect',
          label: 'Additional Services',
          required: false,
          options: [
            { value: 'wifi', label: 'Internet Package' },
            { value: 'excursions', label: 'Shore Excursions' },
            { value: 'spa_package', label: 'Spa Package' },
            { value: 'photo_package', label: 'Photo Package' },
            { value: 'laundry', label: 'Laundry Service' },
            { value: 'gratuities', label: 'Pre-paid Gratuities' },
            { value: 'transportation', label: 'Airport Transportation' }
          ]
        }
      }
    }
    // Additional cruise subcategories would follow the same pattern...
  }

  // Additional categories (Activities, Packages, Car Rentals) would follow the same structure
  // For brevity, I'll implement the most commonly used ones first
};

// Helper function to get fields for a specific category and subcategory
export const getQuoteRequestFields = (categoryId, subcategoryId) => {
  return QUOTE_REQUEST_FIELDS[categoryId]?.[subcategoryId] || null;
};

// Helper function to get all available subcategories for a category
export const getAvailableSubcategories = (categoryId) => {
  return Object.keys(QUOTE_REQUEST_FIELDS[categoryId] || {}).map(subcategoryId => ({
    id: parseInt(subcategoryId),
    ...QUOTE_REQUEST_FIELDS[categoryId][subcategoryId]
  }));
};
